import { jsxs, jsx } from 'react/jsx-runtime';
import { Space } from '@sravni/react-design-system';
import { Heading, Text } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile } from '@sravni/react-utils';

var Feature = function (_a) {
    var title = _a.title, subtitle = _a.subtitle;
    var isMobile = useIsMobile();
    return (jsxs(Space, { direction: "vertical", children: [jsx(Heading, { level: isMobile ? 4 : 5, children: title }), jsx(Text, { size: isMobile ? 12 : 14, nowrap: true, children: subtitle })] }));
};

export { Feature };
//# sourceMappingURL=Feature.js.map
